const BalanceTypes: any = {
  CURRENT: 'Current',
  COLLECTED: 'Collected',
  AVAILABLE: 'Available',
};

export default BalanceTypes;
